import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IsPermissionExist } from 'src/app/helpers/get-permissions';
import {
  PspEvaPermission,
  PspLillyPermission,
  PspRochePermission,
} from 'src/app/_constants/permissions.constant';
import {
  IProducts,
  IPspPharmacyDetails,
  IStock,
} from 'src/app/_models/PSP/psp-pharmacy-details.model';
import { Company } from 'src/app/_models/company.model';
import { CompanyService } from 'src/app/_services/company.service';
import { PspPharmacyDetailsService } from 'src/app/_services/PSP/psp-pharmacy-details.service';
import {
  IRequestItem,
} from 'src/app/_models/PSP/psp-history-requests.model';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { IStockHistoryitem } from 'src/app/_models/PSP/psp-history-stock.model';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AddStockModalComponent } from '../add-stock-modal/add-stock-modal.component';
import { PspCompanyEnum } from 'src/app/enums/psp-company.enum';

@Component({
  selector: 'app-pharmacy-details',
  templateUrl: './pharmacy-details.component.html',
  styleUrls: ['./pharmacy-details.component.scss']
})
export class PharmacyDetailsComponent implements OnInit {

  pharmacyErpId: string;
  pspCompanyId: number[];
  currentCompanyId: number;
  pharmacyDetails: IPspPharmacyDetails;
  eligiblePrograms: string[] = [];
  eligibleHistory: string[] = [];
  products: IProducts[] = [];
  modifiedProductsList: IStock[] = [];
  modifiedRequestHistoryList: IRequestItem[] = [];
  itemRequestHistory: IRequestItem[] = [];
  itemStockHistory: IStockHistoryitem[] = [];
  modifiedStockHistoryList: IStockHistoryitem[] = [];
  mappedProductList: {
    programname: string;
    companyname: string;
    currentfoc: number;
    currentemptybox: number;
    currentstock: number;
    availablefoc: number;
    availablestock: number;
  }[] = [];
  mappedRequestHistoryList: {}[] = [];
  mappedStockHistoryList: {}[] = [];
  isSuperAdmin: boolean;
  isHistory: boolean;
  companies: Company[];
  pageSwitch: boolean;
  pageSize: number = 25;
  totalPages: number = 2;
  currentPage: number = 1;
  totalItems: number;
  historyType: string;
  scroll: boolean;
  loading = false;
  programId: number;
  currentHistoryPageId: number = 1;
  addStockbutton: { name: string }[] = [{ name: 'Add Stock' }];
  addStockbody: {
    erpPharmacyId: string,
    programId: number,
    stock: number,
    foc: number,
    isResetEmptyBox: boolean
  };
  addedStock: IStock;
  modalRef: BsModalRef;
  theadArray = [
    'Program Name',
    'Company Name',
    'Current Stock',
    'Current Empty Box',
    'Current FOC',
    'Available Stock',
    'Available FOC',
  ];
  trequestHistory = [
    'Program Name',
    'Number of purchased stock',
    'Number of purchased FOC',
    'Number of Empty Boxes',
    'Discount Applied',
    'Order Quantity',
    'Public Price',
    'Discount Percentage',
    'Total Price After Discount',
    'Creation Date',
    'Discharge Date',
    'Notes',
    'Patient PSP ID',
    'Patient Full Name',
    'Patient Mobile Number',
  ];
  tstockHistory = [
    'Program Name',
    'Number of purchased stock',
    'Number of purchased FOC',
    'Number of Empty Boxes',
    'Creation Date',
  ];



  constructor(
    private pspPharmacyDetailsService: PspPharmacyDetailsService,
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.pharmacyErpId = this.activatedRoute.snapshot.queryParams.pharmacyErpId;
    this.pspPharmacyDetailsService
      .getPharmacyDetails(this.pharmacyErpId)
      .subscribe((res) => (this.pharmacyDetails = res.data));
    this.companyService.getAllCompanies().subscribe((res) => {
      this.companies = [...res.data?.companies];
      this.currentCompanyId = this.getEvaCompanyId(this.companies);
      this.getPspCurrentStockProducts(this.currentCompanyId);
    });
    this.getEligiblePrograms();
    this.eligibleHistory = [
      'Request',
      'Stock',
    ];
    this.getRequestHistory(
      this.scroll,
      this.pharmacyErpId,
      this.currentPage,
      this.pageSize
    );

  }

  getEvaCompanyId(companies: Company[]) {
    return companies.find(company => company.name.toLowerCase().includes("eva")).id;
  }

  getLillyCompanyId(companies: Company[]) {
    return companies.find(company => company.name.toLowerCase().includes("lilly")).id;
  }

  getRocheCompanyId(companies: Company[]) {
    return companies.find(company => company.name.toLowerCase().includes("roche")).id;
  }

  getPspCurrentStockProducts(companyId: number) {
    if (
      IsPermissionExist(PspEvaPermission) &&
      IsPermissionExist(PspLillyPermission) &&
      IsPermissionExist(PspRochePermission)
    ) {
      this.isSuperAdmin = true;
      this.pspPharmacyDetailsService
        .getCurrentStock(this.pharmacyErpId, companyId)
        .subscribe((res) => {
          this.modifiedProductsList = res.data.stocks;
          this.mappedProductList = this.modifyTableInputsForPspPharmacyProducts(
            this.modifiedProductsList
          );
        });
    } else {
      this.pspPharmacyDetailsService
        .getCurrentStock(this.pharmacyErpId, null)
        .subscribe((res) => {
          this.modifiedProductsList = res.data.stocks;
          this.mappedProductList = this.modifyTableInputsForPspPharmacyProducts(
            this.modifiedProductsList
          );
        });
    }
  }
  buttonAddStockClicked(event, programId): void {
    this.programId = event.rowData.programid;

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        title: 'Add Stock',
      },
    };

    this.modalRef = this.modalService.show(
      AddStockModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((response) => {
      if (!response) {
        return;
      }

      this.spinner.show();

      this.addStockbody = {
        erpPharmacyId: this.pharmacyErpId,
        programId: event.rowData.programid,
        stock: response.stock,
        foc: response.foc,
        isResetEmptyBox: response.isResetEmptyBox
      };

      this.pspPharmacyDetailsService
        .addStock(this.addStockbody)
        .subscribe(() => {
          this.cdr.detectChanges();
          this.getPspCurrentStockProducts(this.currentCompanyId);
          this.getStockHistory(
            this.scroll,
            this.pharmacyErpId,
            1,
            this.pageSize
          );
        });
    });
  }

  getEligiblePrograms() {
    if (
      IsPermissionExist(PspEvaPermission) &&
      IsPermissionExist(PspLillyPermission)
    ) {

      this.eligiblePrograms = this.eligiblePrograms.concat([
        'Eva Programs',
        'Lilly Programs',
      ]);
    }
  }


  getRequestHistory(scroll = false, pharmacyErpId, currentPage, pageSize) {
    this.pspPharmacyDetailsService.
      getPspPharmacyRequestsHistory(
        pharmacyErpId,
        currentPage,
        pageSize
      )
      .subscribe((response) => {
        this.loading = true;
        this.spinner.show();
        this.itemRequestHistory = response.data.items
        this.modifiedRequestHistoryList = scroll ? [...this.modifiedRequestHistoryList.concat(response.data.items)] : response.data.items;
        this.mappedRequestHistoryList = this.modifyTableInputsForPspPharmacyRequestHistory(
          this.modifiedRequestHistoryList
        );
        this.totalPages = response.data.pagination.totalPages;
        this.currentPage = response.data.pagination.currentPage;
        this.totalItems = response.data.pagination.totalItems;
        pageSize = this.pageSize;
        this.spinner.hide();
      })
  }

  getStockHistory(scroll = false, pharmacyErpId, currentPage, pageSize) {
    this.pspPharmacyDetailsService.
      getPspPharmacyStockHistory(
        pharmacyErpId,
        currentPage,
        pageSize
      ).subscribe((res) => {
        this.loading = true;
        this.spinner.show();
        this.itemStockHistory = res.data.items;
        this.modifiedStockHistoryList = scroll ? [...this.modifiedStockHistoryList.concat(res.data.items)] : res.data.items;
        this.mappedStockHistoryList = this.modifyTableInputsForPspPharmacyStockHistory(this.modifiedStockHistoryList);
        this.totalPages = res.data.pagination.totalPages;
        this.currentPage = res.data.pagination.currentPage;
        this.totalItems = res.data.pagination.totalItems;
        this.spinner.hide();
      })
  }

  modifyTableInputsForPspPharmacyProducts(products: IStock[]) {
    this.theadArray = [
      'Program Name',
      'Company Name',
      'Current Stock',
      'Current Empty Box',
      'Current FOC',
      'Available Stock',
      'Available FOC',
    ];
    return products.map((p) => {
      return {
        programid: p.programId,
        programname: p.programName,
        companyname: p.companyName,
        currentstock: p.currentStock,
        currentemptybox: p.currentEmptyBoxes,
        currentfoc: p.currentFoc,
        availablestock: p.availableStock,
        availablefoc: p.availableFoc,
      };
    });
  }

  modifyTableInputsForPspPharmacyRequestHistory(requestHistory: IRequestItem[]) {
    this.trequestHistory = [
      'Program Name',
      'Number of purchased stock',
      'Number of purchased FOC',
      'Number of Empty Boxes',
      'Discount Applied',
      'Order Quantity',
      'Public Price',
      'Discount Percentage',
      'Total Price After Discount',
      'Creation Date',
      'Discharge Date',
      'Notes',
      'Patient PSP ID',
      'Patient Full Name',
      'Patient Mobile Number',
    ];
    return requestHistory.map((r) => {
      return {
        id: r.request.id,
        programname: r.request.programName,
        numberofpurchasedstock: r.request.discountField == true ? '' : r.request.stock,
        numberofpurchasedfoc: r.request.discountField == true ? '' : r.request.foc,
        numberofemptyboxes: r.request.discountField == true ? '' : r.request.emptyBoxes,
        discountapplied: r.request.discountField == true ? 'Yes' : 'No',
        orderquantity: r.request.quantity == 0 || null ? '' : r.request.quantity,
        publicprice: r.request.publicPrice == 0 || null ? '' : r.request.publicPrice,
        discountpercentage: r.request.percentageOfTheDiscount == 0 || null ? '' : r.request.percentageOfTheDiscount + '%',
        totalpriceafterdiscount: r.request.totalPriceAfterDiscount == 0 || null ? '' : r.request.totalPriceAfterDiscount,
        notes: r.request.notes,
        creationdate: this.datePipe.transform(
          r.request.creationDate,
          'MMM d, y, h:mm a'
        ),
        dischargedate: this.datePipe.transform(
          r.request.dischargeDate,
          'MMM d, y, h:mm a'
        ),
        patientfullname: r.patient.fullName,
        patientmobilenumber: r.patient.phone,
        patientpspid: r.patient.pspCode
      };
    });
  }

  modifyTableInputsForPspPharmacyStockHistory(stockHistory: IStockHistoryitem[]) {
    this.tstockHistory = [
      'Program Name',
      'Number of purchased stock',
      'Number of purchased FOC',
      'Number of Empty Boxes',
      'Creation Date',
    ];
    return stockHistory.map((s) => {
      return {
        id: s.Id,
        programname: s.programName,
        numberofpurchasedstock: s.stock,
        numberofpurchasedfoc: s.foc,
        numberofemptyboxes: s.emptyBoxes,
        creationdate: this.datePipe.transform(
          s.creationDate,
          'MMM d, y, h:mm a'
        ),
      };
    });
  }



  changePageId(pageId) {
    if (pageId === PspCompanyEnum.Eva) {
      this.currentCompanyId = this.getEvaCompanyId(this.companies);
    } else if (pageId === PspCompanyEnum.Lilly) {
      this.currentCompanyId = this.getLillyCompanyId(this.companies);
    } else if (pageId === PspCompanyEnum.Roche) {
      this.currentCompanyId = this.getRocheCompanyId(this.companies);
    }
    this.getPspCurrentStockProducts(this.currentCompanyId);
  }

  changePageIdHistory(pageId) {
    this.currentPage = 1;
    if (pageId == 1) {
      this.currentHistoryPageId = 1;
      this.getRequestHistory(
        this.scroll,
        this.pharmacyErpId,
        this.currentPage,
        this.pageSize
      );
    } else if (pageId == 2) {
      this.currentHistoryPageId = 2;
      this.getStockHistory(
        this.scroll,
        this.pharmacyErpId,
        this.currentPage,
        this.pageSize
      )
    }
  }

  onScrollDown() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getRequestHistory(
        true,
        this.pharmacyErpId,
        this.currentPage,
        this.pageSize
      );
    }
  }

}
